<app-icon-button
  class="d-flex"
  [busy]="isUpdatingLocation$ | async"
  icon="/assets/location.svg"
  (click)="updateLocation()"
></app-icon-button>
